import { DarePlatform, Platform } from 'root/src/shared/@types/platforms';
export function getReadablePlatform(platform) {
    switch (platform) {
        case Platform.Twitch:
            return 'Twitch';
        case Platform.TikTok:
            return 'TikTok';
        case Platform.YouTube:
            return 'YouTube';
        default:
            return undefined;
    }
}
export function getReadableDarePlatform(darePlatform) {
    switch (darePlatform) {
        case DarePlatform.Twitch:
            return 'Twitch';
        case DarePlatform.TikTok:
            return 'TikTok';
        case DarePlatform.YouTube:
            return 'YouTube';
        case DarePlatform.YouTubeShorts:
            return 'YouTube Shorts';
        case DarePlatform.X:
            return 'X';
        default:
            return undefined;
    }
}
